import { Injectable } from '@angular/core';

const GO_FRAME_ID = 'go-print';

@Injectable({ providedIn: 'root' })
export class GoPrintService {
	private getFrame (): HTMLIFrameElement {
		let printFrame = document.querySelector(`iframe#${GO_FRAME_ID}`) as HTMLIFrameElement | null;
		if (!printFrame) {
			printFrame = document.createElement('iframe');
			printFrame.setAttribute('style', 'position:absolute;left:-9999px;');
			printFrame.setAttribute('width', '650px');
			printFrame.setAttribute('height', '800px');
			printFrame.setAttribute('id', GO_FRAME_ID);
		}
		return printFrame;
	}

	private stripScriptsAndTitle (headString: string): string {
		const div = document.createElement('div');
		div.innerHTML = headString;
		const scripts = div.getElementsByTagName('script');
		let i = scripts.length;
		while (i--) {
			const s = scripts[i];
			if (s.parentNode) {
				s.parentNode.removeChild(s);
			}
		}
		const title = div.querySelector('title');
		if (title && title.parentNode) {
			title.parentNode.removeChild(title);
		}
		return div.innerHTML;
	}

	public print (element: HTMLElement, title: string = document.title): void {
		const printFrame = this.getFrame();

		const headContent = this.stripScriptsAndTitle(document.querySelector('head')!.innerHTML);

		const tempDiv = document.createElement('div');
		tempDiv.appendChild(element.cloneNode(true));

		printFrame.onload = () => {
			printFrame.contentDocument.head.innerHTML = `
				${headContent}
				<title>${title}</title>
				<style>html, body { overflow: auto !important; display: initial !important; } @media print { * { transition: none !important; }}</style>
			  `;
			printFrame.contentDocument.body.innerHTML = tempDiv.innerHTML;
			setTimeout(() => {
				try {
					(printFrame as HTMLIFrameElement).focus();
					(printFrame as HTMLIFrameElement).contentWindow?.print();
				} catch {
					// no-op
				}
			}, 1000); // Allow CSS/DOM time to render
		};

		window.document.body.appendChild(printFrame);
	}
}
